import { focus, ink } from '../../UI/tokens';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FormLabel } from 'react-bootstrap';

export const SLinkContainer = styled.div`
  padding: 0; margin: 4px 0; border-radius: 9px;
  @media (max-width: 768px) { display: ${({ $baropen }) => $baropen ? 'block' : 'none'}; }
`;
export const SLink = styled(FormLabel)`
  display: flex; align-items: center; width: 100%; margin: 0;
  border: 0; border-radius: 9px; cursor: pointer;
  color: ${ink}; text-decoration: none;
  background: ${({ $menuopen }) => $menuopen ? 'rgba(80,115,175,.12)' : 'transparent'};
  font-size: 13px; font-weight: 600;
  ${focus}
`;
export const SLinkSubnav = styled(Link)`
  display: flex; width: 100%; align-items: center;
  color: ${ink}; text-decoration: none; border-radius: 9px;
  &:hover { color: ${ink}; text-decoration: none; }
  ${focus}
`;
export const SLinkLabel = styled.span`
  flex: 1; min-width: 0; margin-left: 10px; line-height: 1.4;
`;
export const SLinkIcon = styled.div`
  display: flex; align-items: center; svg { font-size: 19px; }
`;
export const SLinkNotification = styled.div`
  padding: 2px 7px; margin-left: auto; border-radius: 6px;
  background: #e9effc; color: #315cbe; font-size: 11px; font-weight: 700;
`;
